<!-- 人选进展各种操作弹层 在用 -->
<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal="false"
      top="60px"
      class="rpg-dialog"
    >
      <div v-if="dialogVisible && activeComponent" class="rde-card">
        <component
          v-if="activeComponent"
          v-bind:is="activeComponent"
          ref="compt"
          :radish="radish"
          :project="project"
          :on-confirm="handleConfirm"
        ></component>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import RecommendCreate from '../progress2/recommend-create'
import RecommendFeedback from '../progress2/recommend-feedback'
import InterviewCreate from '../progress2/interview-create'
import InterviewEdit from '../progress2/interview-edit'
import InterviewFeedback from '../progress2/interview-feedback'
import InterviewGuide from '../progress2/interview-guide'
import OfferMaybe from '../progress2/offer-maybe'
import OfferFeedback from '../progress2/offer-feedback'
import OfferConfirm from '../progress2/offer-confirm'
import OfferEdit from '../progress2/offer-edit'
import LeaveGuide from '../progress2/leave-guide'
import ToworkConfirm from '../progress2/towork-confirm'
import ToworkNot from '../progress2/towork-not'
import WarrantyConfirm from '../progress2/warranty-confirm'
import WarrantyNot from '../progress2/warranty-not'
import BackgroundResearch from '../progress2/background-research'
export default {
  components: {
    RecommendCreate,
    RecommendFeedback,
    InterviewCreate,
    InterviewEdit,
    InterviewFeedback,
    InterviewGuide,
    OfferMaybe,
    OfferFeedback,
    OfferConfirm,
    OfferEdit,
    LeaveGuide,
    ToworkConfirm,
    ToworkNot,
    WarrantyConfirm,
    WarrantyNot,
    BackgroundResearch,
  },
  props: {
    onConfirm: {
      type: Function,
      default: function() {},
    },
  },
  data() {
    return {
      dialogVisible: false,
      radish: {},
      project: {},
      activeComponent: '',
    }
  },
  methods: {
    async open(params) {
      const { radish, project, compName, defaultData, defaultResult } = params
      this.activeComponent = compName
      this.radish = radish
      this.project = project
      this.$nextTick(()=>{
        this.dialogVisible = true
        this.$nextTick(()=>{
          if (defaultData) this.$refs.compt.form = Object.assign(this.$refs.compt.form, defaultData)
          if (defaultResult) this.$refs.compt.result = defaultResult
        })
      })
    },
    async handleConfirm() {
      this.onConfirm()
      if (this.activeComponent != 'RecommendFeedback' && this.activeComponent != 'InterviewFeedback') {
        this.dialogVisible = false
      }
    },
  },
}
</script>
